import React from 'react';
import { BaseFilterProps } from '../../../common/BaseFilter';
import { DateTimeFilter } from '../../../DateTimeFilter';
import { FilterProps } from '../../../common/filter.util';
import { AssetSignedAtFilterContent } from './Content/AssetSignedAtFilterContent';

export class AssetSignedAtFilter extends DateTimeFilter {
  toComponent(props: BaseFilterProps): React.JSX.Element {
    return <AssetSignedAtFilterContent props={props} />;
  }

  static filter(filterProps: FilterProps, item?: Date) {
    if (!item) return true;
    if (!filterProps.assetSignedAt) return true;
    return item >= new Date(filterProps.assetSignedAt.start) && item <= new Date(filterProps.assetSignedAt.end);
  }
}
